<template>
  <div class="card">
    <div class="card-header"><i class="icon-refresh"></i> Filtrer</div>
    <div class="card-block">
      <div class="row">
        <div class="form-group col-sm-3">
          <label>Type</label>
          <multiselect
            v-model="filters.type"
            :options="typesOptions"
            :multiple="true"
            label="label"
            track-by="label"
            class="custom-multiselect"
            placeholder="Choisir un type"
          >
          </multiselect>
        </div>
        <div class="form-group col-sm-3">
          <label>Commercial</label>
          <multiselect
            placeholder="Choisir un ou des commerciaux"
            v-model="filters.commercials"
            :options="commercials"
            label="label"
            track-by="label"
            class="custom-multiselect"
            :multiple="true"
          >
          </multiselect>
        </div>
        <div class="form-group col-sm-3">
          <label>Coach manager / Marchés public</label>
          <multiselect
            placeholder="Choisir un ou des coach managers"
            v-model="filters.coachManagers"
            :options="coachManagers"
            label="label"
            track-by="label"
            class="custom-multiselect"
            :multiple="true"
          >
          </multiselect>
        </div>
      </div>
    </div>
    <div class="card-footer">
      <div class="row">
        <div class="col-md-6">
          <button
            type="button"
            class="btn btn-sm btn-secondary"
            @click="applyFilters"
          >
            <i class="icon-eye"></i>&nbsp; Visualiser
          </button>
        </div>

        <div class="col-md-6">
          <div class="text-right">
            <button
              class="btn btn-primary"
              @click="pushAll"
              :disabled="pushLoading"
              v-if="hasPermission($store.state.user, 'ATTRIBUTIONS_WRITE')"
            >
              <i class="icon-paper-plane"></i> Relance Push
            </button>

            <button
              v-if="hasPermission($store.state.user, 'ATTRIBUTIONS_WRITE')"
              class="btn btn-success ml-1 float-right"
              @click="isOpenCreateAttributionModal = true"
            >
              <i class="fa fa-plus"></i> Créer une attribution
            </button>
          </div>
        </div>
      </div>
    </div>

    <ModalCreateAttribution
      :isShow="isOpenCreateAttributionModal"
      @close="isOpenCreateAttributionModal = false"
    />
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import { mapState } from "vuex";

import ModalCreateAttribution from "@/components/modal/ModalCreateAttribution.vue";

export default {
  components: {
    Multiselect,
    ModalCreateAttribution,
  },
  props: {
    default: {
      type: Object,
      required: true,
    },
    pushLoading: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      filters: {
        commercials: [],
        coachManagers: [],
        type: [],
      },
      commercials: [],
      coachManagers: [],
      typesOptions: [
        { label: "B2C", value: "isB2C" },
        { label: "B2B", value: "isB2B" },
        { label: "Marchés publics", value: "marketEstablishment" },
      ],

      isOpenCreateAttributionModal: false,
    };
  },

  computed: {
    ...mapState({
      user: (state) => state.user,
    }),
  },

  async created() {
    this.filters = { ...this.filters, ...this.default };

    await this.fetchCommercials();
    await this.fetchCoachManagers();

    if (
      this.filters.commercials.length === 0 &&
      this.commercials &&
      this.commercials.filter((c) => c.value === this.user.email).length > 0 &&
      this.user.commercial &&
      this.hasPermission(this.$store.state.user, "ATTRIBUTIONS_FILTERS_WRITE")
    ) {
      this.filters.commercials.push({
        value: this.user.email,
        label: this.user.commercial.pseudo || this.user.firstName,
      });
    }

    if (
      this.filters.coachManagers.length === 0 &&
      this.coachManagers &&
      this.coachManagers.filter((c) => c.value === this.user.email).length >
        0 &&
      this.user.coachManager &&
      this.hasPermission(
        this.$store.state.user,
        "ATTRIBUTIONS_FILTERS_COACH_MANAGER_WRITE",
      )
    ) {
      this.filters.coachManagers.push({
        value: this.user.email,
        label: this.user.coachManager.pseudo || this.user.firstName,
      });

      this.filters.type = this.typesOptions.filter(
        (opt) => !!this.user.coachManager[opt.value],
      );
    }

    this.applyFilters();
  },

  methods: {
    applyFilters() {
      this.$emit("applyFilters", {
        ...this.filters,
        type:
          this.filters.type?.length > 0
            ? this.filters.type.map((t) => t.value)
            : null,
      });
    },

    pushAll() {
      this.$emit("pushAll");
    },

    async fetchCommercials() {
      const { data } = await this.$api.get("/users/commercials/search");

      this.commercials = data.map((c) => ({
        value: c.email,
        label: c.commercial.pseudo,
      }));
    },

    async fetchCoachManagers() {
      const { data } = await this.$api.get("/users/coach-managers");

      this.coachManagers = data.map((c) => ({
        value: c.email,
        label: c.coachManager.pseudo,
      }));
    },
  },
};
</script>
